export default __webpack_public_path__ + "static/O4-major-469f4d4b2d4b84305ee128e40e5cd3f6.png";